<template>
  <div class="order-second" v-loading.fullscreen.lock="loading">
    <div class="crumbs-navigation">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main' }">{{ $t('createQuotation.myQuotation') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('createQuotation.productConfigurationList') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="flow-chart">
      <div class="el-steps el-steps--horizontal" style="justify-content: center;">
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; margin-right: 0px;">
          <div class="el-step__head is-finish">
            <div class="el-step__line" style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: 0ms; border-width: 0px; width: 0%;"
              />
            </div>
            <div class="el-step__icon is-icon" @click="jump1Step(projectId,projectName)">
              <i class="el-step__icon-inner step1selected" />
            </div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-finish">{{ $t('createQuotation.projectBasicInformation') }}</div>
            <div class="el-step__description is-finish" />
          </div>
        </div>
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; margin-right: 0px;">
          <div class="el-step__head is-finish">
            <div class="el-step__line" style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: -150ms; border-width: 0px; width: 0%;"
              />
            </div>
            <div class="el-step__icon is-icon">
              <i class="el-step__icon-inner step2selected" />
            </div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-finish">{{ $t('createQuotation.productConfigurationList') }}</div>
            <div class="el-step__description is-finish" />
          </div>
        </div>
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; margin-right: 0px;">
          <div class="el-step__head is-wait">
            <div class="el-step__line" style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: -300ms; border-width: 0px; width: 0%;"
              />
            </div>
            <div class="el-step__icon is-icon" @click="nextStepToCreatOrderThird">
              <i class="el-step__icon-inner step3unselect" />
            </div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-wait">{{ $t('createQuotation.discountInformation') }}</div>
            <div class="el-step__description is-wait" />
          </div>
        </div>
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; max-width: 25%;">
          <div class="el-step__head is-wait">
            <div class="el-step__line"><i class="el-step__line-inner" /></div>
            <div class="el-step__icon is-icon" @click="jump4Step(projectId,projectName)">
              <i class="el-step__icon-inner step4unselect" />
            </div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-wait">{{ $t('createQuotation.exportShare') }}</div>
            <div class="el-step__description is-wait" />
          </div>
        </div>
      </div>
    </div>
    <div class="select-option">
      <el-row>
        <el-col :span="24">
          <div class="grid-content ">
            {{ $t('createQuotation.theNameList') }}
            <span class="f-blue">
              {{ projectName }}
            </span>
          </div>
          <div class="grid-content ">
            <a>
              <!--目录总价-->
              {{ $t('createQuotation.catalogPrice') }}
              <span style="color: #fd7f57 !important; font-weight: 700">
                {{ productPriceFormat(null,null,getSummaries) }}
              </span>
            </a>
          </div>
          <div
            class="blue-btn-pei mar-10"
            @click="dialogServiceFormVisible = true"
            v-if="!isHaveServiceConfig"
          >
            <a>{{ $t('createQuotation.addServiceConfigurationGroup') }}</a>
          </div>
          <div class="blue-btn-pei" @click="dialogFormVisible = true">
            <a>{{ $t('createQuotation.addGeneralConfigurationGroup') }}</a>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="clear" />
    <div class="table">
      <el-table
        id="table0001"
        :data="tableData3"
        border
        style="width: 100%;"
        row-key="groupId"
        :header-cell-style="{background:'#eef1f6','text-align': 'left'}"
      >
        <el-table-column
          prop="groupName"
          :render-header="foo"
          :label="$t('createQuotation.configurationGroupName')"
          align="left"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="editName(scope.row)"
            >
              {{ scope.row.groupName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="isServiceFlag"
          :label="$t('createQuotation.configurationSetType')"
          align="left"
          width="150px"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.isServiceFlag"
              class="order-second-table-service"
            >&nbsp;
              {{ $t('createQuotation.service') }}
            </span>
            <span
              v-if="(!scope.row.isServiceFlag && scope.row.groupDistinguish != null && scope.row.groupDistinguish === 3)||(!scope.row.isServiceFlag && scope.row.groupDistinguish != null && scope.row.groupDistinguish === 4)"
              class="order-second-table-change"
            >&nbsp;
              <!--场景化-->
              {{ $t('createQuotation.service') }}
            </span>
            <span
              v-if="!scope.row.isServiceFlag && scope.row.groupDistinguish == null"
              class="order-second-table-conventional"
            >&nbsp;
              <!--常规-->
              {{ $t('createQuotation.conventional') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="totalPrice"
          :label="$t('createQuotation.catalogPrice')"
          align="right"
          :formatter="productPriceFormat"
        />
        <el-table-column
          prop="addDateTime"
          :label="$t('createQuotation.creationDate')"
          align="left"
          width="140px"
        />
        <el-table-column
          :label="$t('createQuotation.operation') "
          align="left"
        >
          <template slot-scope="scope">
            <el-button @click="addGroup(scope.row)" v-if="scope.row.groupDistinguish !== 3" type="text">
              <!--添加产品-->
              {{ $t('createQuotation.addProduct') }}
            </el-button>
            <el-button @click="editScene(scope.row)" type="text" v-if="scope.row.groupDistinguish === 3">
              <!--修改方案-->
              {{ $t('createQuotation.modifyProgram') }}
            </el-button>
            <el-button @click="editGroup(scope.row)" type="text" style="margin: 0px 10px">
              <!--修改产品-->
              {{ $t('createQuotation.modifyProduct') }}
            </el-button>
            <el-button @click="copyGroup(scope.row)" v-if="!scope.row.isServiceFlag && (!scope.row.isServiceFlag && scope.row.groupDistinguish !== 3)" type="text">
              <!--复制-->
              {{ $t('createQuotation.copy') }}
            </el-button>
            <el-button @click="deleteGroup(scope.row)" type="text" style="margin: 0px 10px">
              <!--删除-->
              {{ $t('createQuotation.delete') }}
            </el-button>
            <span class="paixu" v-if="!scope.row.isServiceFlag" style="white-space: nowrap;">
              <!--拖动-->
              {{ $t('createQuotation.drag') }}
              <!--<img src="../../assets/updown.png" alt="err">-->
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="btn-p">
      <el-button @click="lastStepToCreatOrderFirst">
        <!--上一步，项目基本信息-->
        {{ $t('createQuotation.previousStepBasicInformation') }}
      </el-button>
      <el-button type="primary" @click="nextStepToCreatOrderThird">
        <!--下一步，填写产品折扣-->
        {{ $t('createQuotation.nextProductDiscounts') }}
      </el-button>
    </div>
    <el-dialog
      custom-class="my-dialog"
      :title="$t('createQuotation.addConfigurationSet')"
      :visible.sync="dialogFormVisible"
      width="450px"
    >
      <el-form
        :model="configurationGroup"
        :rules="rules"
        ref="configurationGroup"
        :inline="true"
        @submit.native.prevent
        @keyup.enter.native="addConfiguration(0)"
      >
        <el-form-item
          :label="$t('createQuotation.configurationGroupName')"
          label-width="160px"
          prop="groupName"
        >
          <el-input
            v-model.trim="configurationGroup.groupName"
            :placeholder="$t('createQuotation.enterGroupName')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('createQuotation.cancel') }}</el-button>
        <el-button type="primary" @click="addConfiguration(0)">{{ $t('createQuotation.add') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      custom-class="my-dialog"
      :title="$t('createQuotation.addServiceConfigurationGroup')"
      :visible.sync="dialogServiceFormVisible"
      width="450px"
    >
      <el-form
        :model="configurationGroup"
        :rules="rules"
        ref="configurationGroup"
        :inline="true"
        @submit.native.prevent
        @keyup.enter.native="addConfiguration(1)"
      >
        <el-form-item
          :label="$t('createQuotation.configurationGroupName')"
          label-width="160px"
          prop="groupName"
        >
          <el-input
            v-model.trim="configurationGroup.groupName"
            :placeholder="$t('createQuotation.enterGroupName')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogServiceFormVisible = false">
          {{ $t('createQuotation.cancel') }}
        </el-button>
        <el-button
          type="primary"
          @click="addConfiguration(1)"
        >
          {{ $t('createQuotation.add') }}
        </el-button>
      </div>
    </el-dialog>

    <!--修改配置组-->
    <el-dialog
      custom-class="my-dialog"
      :title="$t('createQuotation.modifyConfigurationGroupName')"
      :visible.sync="groupNameVisible"
      width="450px"
    >
      <el-form
        :model="updateGroupName"
        :rules="rules"
        ref="updateGroupName"
        :inline="true"
        @submit.native.prevent
        @keyup.enter.native="updateConfiguration"
      >
        <el-form-item
          :label="$t('createQuotation.configurationGroupName')"
          label-width="160px"
          prop="groupName"
        >
          <el-input
            v-model.trim="updateGroupName.groupName"
            :placeholder="$t('createQuotation.enterGroupName')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="groupNameVisible = false">
          {{ $t('createQuotation.cancel') }}
        </el-button>
        <el-button type="primary" @click="updateConfiguration()">
          {{ $t('createQuotation.add') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../api';
import step from '../../utils/step';
import { productPriceFormat } from '@/utils/numberFormater';
import Sortable from 'sortablejs';
import { getStore, setStore, isPartnerM } from '@/utils/mUtils';
export default {
  mixins: [step],
  name: 'CreatOrderSecond',
  data () {
    return {
      dialogFormVisible: false,
      groupNameVisible: false,
      dialogServiceFormVisible: false,
      groupNameT: '',
      configurationGroup: {
        groupName: 'Site_1',
        projectId: '',
        isServiceFlag: false
      },
      updateGroupName: {
        projectId: '',
        groupId: '',
        groupName: ''
      },
      formLabelWidth: '120px',
      tableData3: [],
      projectId: '',
      projectName: '',
      totalPrice: '',
      orderStr: '0',
      // 表单验证
      rules: {
        groupName: [
          { required: true, message: this.$t('createQuotation.enterGroupName'), trigger: 'blur' },
          { max: 40, message: this.$t('createQuotation.moreCharacters') }
        ]
      },
      isHaveServiceConfig: false,
      saveFlag: false,
      loading: false,
      isPartner: true
    };
  },
  mounted () {
    // 获取url 参数
    this.projectId = this.$route.query.projectId;
    // this.projectName = this.$route.query.projectName;
    this.projectName = getStore('secondProjectName');
    this.getConfigurationGroup();
    this.isPartner = isPartnerM();
  },
  destroyed () {
    if (this.saveFlag) {
      this.saveConfingGroupOrder();
    }
  },
  computed: {
    getSummaries () {
      let newTotalPrice = 0;
      let serviceFlg = true;
      this.tableData3.forEach((item) => {
        if (!isNaN(item.totalPrice)) {
          newTotalPrice += item.totalPrice;
        }
        // 判断报价单项目中是否已经包含服务配置组
        if (serviceFlg && item.isServiceFlag != null && item.isServiceFlag === true) {
          serviceFlg = false;
        }
      });
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.isHaveServiceConfig = !serviceFlg;
      return newTotalPrice;
    }

  },
  methods: {
    productPriceFormat,
    getStore,
    addConfiguration (isService) {
      this.$refs['configurationGroup'].validate((valid) => {
        if (valid) {
          this.configurationGroup.projectId = this.projectId;
          // 等于 1  添加的是服务配置组
          if (isService === 1) {
            this.configurationGroup.isServiceFlag = true;
          } else {
            this.configurationGroup.isServiceFlag = false;
          }
          api.createConfigurationGroup(this.configurationGroup).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              // 添加成功
              // this.$notify.success('添加配置组成功！');
              this.$notify.success(this.$t('createQuotation.addGroupSuccess'));
              // 初始化表单列表
              this.getConfigurationGroup();
            } else {
              // 添加失败
              // this.$notify.error(json.data);
              this.$notify.error(json.data);
            }
          }).catch(() => {
            this.$notify.error(this.$t('createQuotation.networkAnomaly'));
          });
          this.dialogFormVisible = false;
          this.dialogServiceFormVisible = false;
        } else {
          if (isService === 1) {
            this.dialogServiceFormVisible = true;
          } else {
            this.dialogFormVisible = true;
          }
        }
      });
    },
    // 上一步，项目基本信息
    lastStepToCreatOrderFirst () {
      this.$router.push({ name: 'CreatOrderFirst/first', query: { secondProjectId: this.projectId, projectName: this.projectName } });
    },
    // 下一步，配置产品清单
    nextStepToCreatOrderThird () {
      if (this.saveFlag) {
        this.saveFlag = false;
        api.saveConfingGroupOrder(this.tableData3).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$router.push({ name: 'CreatOrderThird/third', query: { secondProjectId: this.projectId, projectName: this.projectName } });
            // 修改成功
            this.$notify.success(this.$t('createQuotation.sortModifySuccess'));
          } else {
            // 修改失败
            this.$notify.error(json.data);
          }
        }).catch(() => {
          this.$notify.info(this.$t('createQuotation.networkAnomaly'));
        });
      } else {
        this.$router.push({ name: 'CreatOrderThird/third', query: { secondProjectId: this.projectId, projectName: this.projectName } });
      }
    },
    // 初始化配置组列表
    getConfigurationGroup () {
      this.loading = true;
      api.getConfigurationGroup({ params: { 'projectId': this.projectId, 'orderStr': this.orderStr } }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData3 = json.data;
          this.rowDrop();
        } else {
          this.$notify.error(json.err);
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$notify.error(`${this.$t('createQuotation.networkAnomaly')}`);
      });
    },
    // 删除配置组
    deleteGroup (row) {
      this.$confirm(`${this.$t('createQuotation.thisPermanentlyDeleteContinue')}`, `${this.$t('createQuotation.prompt')}`, {
        confirmButtonText: this.$t('homePage.confirm'),
        cancelButtonText: this.$t('homePage.takeAway'),
        type: 'warning'
      }).then(() => {
        this.loading = true;
        api.deleteConfigurationGroup({ params: { projectId: row.projectId, groupId: row.groupId } }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$notify({
              type: 'success',
              message:  this.$t('createQuotation.deleteSucceeded')
            });
            // 初始化表格数据
            this.getConfigurationGroup();
          }
        }).catch(() => {
          this.loading = false;
          this.$notify.error(`${this.$t('createQuotation.deleteErrorMessage')}`);
        });
      }).catch(() => {
        this.$notify({
          type: 'info',
          message:`${this.$t('createQuotation.hasBeenDelete')}`
        });
      });
    },
    // 复制配置组
    copyGroup (row) {
      this.$confirm(`${this.$t('createQuotation.thisOperationCopyContinue')}`, `${this.$t('createQuotation.prompt')}`, {
        confirmButtonText: this.$t('createQuotation.confirm'),
        cancelButtonText: this.$t('createQuotation.takeAway'),
        type: 'warning'
      }).then(() => {
        this.loading = true;
        api.copyConfigurationGroup({ params: { projectId: row.projectId, groupId: row.groupId } }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$notify({
              type: 'success',
              message: this.$t('homePage.copySuccess')
            });
            // 初始化表格数据
            this.getConfigurationGroup();
          }
        }).catch(() => {
          this.loading = false;
          this.$notify.error(`${this.$t('createQuotation.copyErrorMessage')}`);
        });
      }).catch(() => {
        this.$notify({
          type: 'info',
          message: this.$t('createQuotation.cancelledCopy')
        });
      });
    },
    // 修改方案
    editScene (row) {
      this.$router.push({ name: 'addSolution', query: { projectId: this.$route.query.projectId, projectName: this.$route.query.projectName, groupId: row.groupId } });
    },
    // 编辑配置组产品
    editGroup (row) {
      let isS = false;
      if (row.isServiceFlag && row.isServiceFlag !== null) {
        isS = true;
      }
      setStore(`AdditionProdLines`, null);
      setStore(`AdditionProdLinesService`, null);
      this.$router.push({
          name: 'AddedProduct/added',
          params: {
            projectId: row.projectId,
            projectName: row.projectName,
            groupId: row.groupId,
            groupName: row.groupName,
            isService: isS,
            groupDistinguish: row.groupDistinguish ? row.groupDistinguish : '1',
            routerPath: 'CreatOrderSecond'
          }
        });
    },
    addGroup (row) {
      let isS = false;
      if (row.isServiceFlag && row.isServiceFlag !== null) {
        isS = true;
      }
      this.$router.push({
        name: 'AdditionProduct/add',
        params: {
          projectId: row.projectId,
          projectName: row.projectName,
          groupId: row.groupId,
          groupName: row.groupName,
          isService: isS,
          routerPath: 'CreatOrderSecond'
        }
      });
    },
    // 修改配置组名称
    editName (row) {
      this.updateGroupName.groupId = row.groupId;
      this.updateGroupName.projectId = row.projectId;
      this.groupNameT = row.groupName;
      this.updateGroupName.groupName = this.groupNameT;
      this.groupNameVisible = true;
    },
    updateConfiguration () {
      if (this.updateGroupName.groupName === this.groupNameT) {
        this.groupNameVisible = false;
        return false;
      }
      this.$refs['updateGroupName'].validate((valid) => {
        if (valid) {
          api.editConfigurationGroup(this.updateGroupName).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              // 修改成功
              this.$notify.success(`${this.$t('createQuotation.editGroupNameSuccess')}`);
              this.groupNameVisible = false;
              this.clearUpdateGroupName();
              this.getConfigurationGroup();
            } else {
              // 修改失败
              this.$notify.error(json.data);
            }
          }).catch(() => {
            this.$notify.info(`${this.$t('createQuotation.networkAnomaly')}`);
          });
        } else {
          this.groupNameVisible = true;
        }
      });
    },
    clearUpdateGroupName () {
      this.groupNameT = '';
      this.updateGroupName.projectId = '';
      this.updateGroupName.groupName = '';
    },
    rowDrop () {
      const tbody = document.querySelector('.el-table__body-wrapper tbody');
      const _this = this;
      Sortable.create(tbody, {
        handle: '.paixu',
        onEnd ({ newIndex, oldIndex }) {
          const currRow = _this.tableData3.splice(oldIndex, 1)[0];
          _this.tableData3.splice(newIndex, 0, currRow);
          _this.saveFlag = true;
        }
      });
    },
    // 保存配置组排序
    saveConfingGroupOrder () {
      api.saveConfingGroupOrder(this.tableData3).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          // 修改成功
          this.$notify.success('修改排序成功！');
        } else {
          // 修改失败
          this.$notify.error(json.data);
        }
      }).catch(() => {
        this.$notify.info(`${this.$t('createQuotation.networkAnomaly')}`);
      });
    },
    foo (h, { column }) {
      if (column.label) {
        return (h('span', {},
          [h('span', [column.label]),
            h('button', {
              attrs: { style: 'float:right;background:none;color:#3fbbdc;border:none;height:2rem;cursor:pointer' },
              on: {
                click: () => {
                  this.reOrder();
                }
              }
            }, [`${this.$t('createQuotation.sequenceShows')}`])]));
      }
    },
    reOrder () {
      this.saveFlag = true;
      if (this.orderStr === '0') {
        this.orderStr = '1';
      } else {
        this.orderStr = '0';
      }
      api.getConfigurationGroup({ params: { 'projectId': this.projectId, 'orderStr': this.orderStr } }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData3 = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch((e) => {
        this.$notify.error(`${this.$t('createQuotation.networkAnomaly')}`);
        console.log(e);
      });
    }
  }
};
</script>

<style lang="scss">
  .my-dialog {
    .el-dialog__header{
      text-align: left !important;
      padding-left: 30px;
    }
    .el-dialog__body{
      padding: 30px 30px 30px 22px;
      .el-form {
        text-align: left;
      }
    }
    .dialog-footer {
      text-align: right;
    }
  }
</style>

<style lang="scss" scoped>
  @import "../../styles/product-common.css";
  .order-second {
    ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #FFFFFF !important;
    }
   ::v-deep .el-step__icon.is-icon{
     width: 6rem !important;
   }
    .order-second-table-service{
      background: #ff5337;
      color: #ffffff;
      text-align:left;
      width: 60px;
      border-radius: 2px;
      //margin: 40px;
      font-weight: bold;
    }
    .order-second-table-change{
      background: #67C23A;
      color: #ffffff;
      text-align:center;
      width: 60px;
      border-radius: 2px;
      font-weight: bold;
    }
    .order-second-table-conventional{
      background: #36BADE;
      color: #ffffff;
      text-align:left;
      width: 60px;
      //margin: 40px;
      border-radius: 2px;
      font-weight: bold;
  }
  }
  .order-second .flow-chart{
    max-width:1200px;
    min-width: 1024px;
    margin: 2rem auto 0;
  }

  .order-second .flow-chart img{
    width: 80%;
    text-align: center;
  }

  .order-second .demo-input-suffix{
    margin-top: 2rem;
  }

  .order-second .demo-input-suffix input{
    height: 3.4rem;
  }

  .order-second .demo-input-suffix .grid-content{
    line-height: 3.4rem;
  }

  textarea:focus {
    border-color: #36BAE2!important;
  }

  .order-second .btn-p{
    margin-top: 5rem;
  }

  .order-second .select-option {
    margin-top: 2rem;
    text-align: left;
  }

  .select-option .f-blue{
    font-weight: 700;
  }
  .order-second {
    .blue-btn-pei {
      background:#fff;
      padding: 0 10px;
      max-height: 32px;
      color: #3fbbdc;
      border: 1px solid #3fbbdc;
      border-radius: 5px;
      text-align: center;
      font-size: 13px;
      cursor: pointer;
      float: right;
    }
    .mar-10 {
      margin-left: 10px;
    }
  }
  .order-second .blue-btn-wite {
    background: rgba(54,186,222,0.1);
    width: 8rem;
    height: 2.2rem;
    color: #36BADE;
    border-radius: 5px;
    line-height: 2.2rem;
    text-align: center;
    font-size: 1.4rem;
    cursor: pointer;
    float: right;
    margin-left: 4px;
    border: 1px solid #36BADE;
  }
  .order-second .el-row,
  .order-second .el-row .el-col,
  .order-second .el-row .grid-content
  {
    height:3.2rem;
    line-height: 3.2rem;
  }
  .order-second .table{
    margin-top: 1rem;
  }
  .order-second .btn-p{
    margin-top: 4rem;
    .el-button {
      width: 20rem;
      //height: 1rem !important;
      line-height: 0;
    }
  }
  .order-second .el-form-item__content{
    width: 40rem;
  }
  .order-second .el-dialog__header{
    text-align: left;
    font-size: 1.6rem;
    border-bottom: 1px solid #EBEBEB;
    padding: 16px 20px 10px;
  }
  .order-second .select-option .grid-content{
    float: left;
    margin-left: 2rem;
  }
  .order-second .select-option .grid-content:first-of-type{
    margin-left: 0;
  }
  .clear{
    clear: both;
  }
  .order-second .el-dialog__footer{
    text-align: right;
  }
  .order-second table .cell{
    white-space: normal;
  }
  .paixu{
    //border: 1px solid #dcdfe6;
    border-radius: 5px;
    padding: 2px 18px 2px 1px;
    color: #36BADE;
    margin-left: 4px;
    position: relative;
    cursor:pointer;
  }
  .paixu img{
    width: 18px;
    height: 16px;
    margin-left: 4px;
    position: absolute;
    right: 1px;
    top: 50%;
    margin-top: -8px;
  }

  @media screen and (max-width: 1367px){
    .order-second .flow-chart img{
      width: 60%;
      text-align: center;
    }
    .order-second .select-option {
      margin-top: 2rem;
    }

    .order-second .el-row,
    .order-second .el-row .el-col,
    .order-second .el-row .grid-content

    {
      height:3.2rem;
      line-height: 3.2rem;
    }

    .order-second .add-configuration{
      margin-top: 1.5rem;
    }

    .order-second .table{
      margin-top: 2.5rem;
    }
    .order-second .btn-p {
      margin-top: 4rem;
    }
    .order-second .flow-chart{
      margin-top: 2rem;
    }
  }
  @media screen and (max-width: 1280px){
    .order-second .btn-p {
      margin-top: 4rem;
    }
    .order-second .cell span{
      font-size: 1.2rem;
    }
    .order-second .orange-btn-pei {
      background:#ff5337;
      width: 12rem;
      height: 2.2rem;
      color: #FFFFFF;
      border-radius: 5px;
      line-height: 2.2rem;
      text-align: center;
      font-size: 1.2rem;
      cursor: pointer;
      float: right!important;
    }
    .order-second .flow-chart{
      margin-top: 2rem;
    }
  }
</style>
